module.exports = __webpack_public_path__ + "img/nnedi-okorafor.625dfea3.png";